import { render, staticRenderFns } from "./CategoriasHierarquia.vue?vue&type=template&id=7c467065&"
import script from "./CategoriasHierarquia.vue?vue&type=script&lang=js&"
export * from "./CategoriasHierarquia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports